<template>
  <div class="short-popup" style="margin-top: 10px;text-align: right;">
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 500, 1000]"
      :page-size="pageSize"
      :pager-count="pagerCount"
      small
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>
<script>
export default {
  props: {
    total: Number,
    pageNum: Number,
  },
  data() {
    return {
      changeColor: "#2062E7",
      currentPage: 1,
      pageSize: 10,
      pagerCount: 5,
    };
  },
  watch: {},
  computed: {},
  mounted() {
    this.currentPage = this.pageNum;
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.$emit("transferName", { pageSize: this.pageSize, current: this.currentPage });
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.current = val;
      this.$emit("transferName", { pageSize: this.pageSize, current: val });
      // console.log(`当前页: ${val}`);
    },
  },
};
</script>
<!--短信链接弹窗-->
<style lang="scss" scoped>
@mixin translate($number, $number2) {
  -webkit-transform: translateX($number) translateY($number2);
  -moz-transform: translateX($number) translateY($number2);
  -ms-transform: translateX($number) translateY($number2);
  -o-transform: translateX($number) translateY($number2);
  transform: translateX($number) translateY($number2);
}
</style>
